import { FC } from 'react';
import { FormItem, OnBlurFormInput, OnChangeFormInput } from '../../../hooks/common/useForm';

import style from './index.module.css';

export const ExtraField: FC<{
  state: FormItem,
  onChange: OnChangeFormInput,
  onBlur: OnBlurFormInput
}> = ({ state, onChange, onBlur }) => {

  return (
    <textarea
      className={style.textarea}
      name={state.name}
      value={state.value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={state.placeholder}
    />
  );
}